/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import * as AST from './AST';
import { parseHtml, nodeTypeToTag } from './HtmlParser';

interface INodeProps {
    node: AST.Node;
}

class NodeView extends React.Component<INodeProps> {
    render() {
        const node = this.props.node;
        // Warning: correct type `React.ReactHTML` here OOMs the compiler
        let Tag: any = nodeTypeToTag(node.type);
        const attr: Record<string, string | number | undefined> = {
            className: node.className,
            id: node.id,
        };
        switch (node.type) {
            case AST.NODE_TYPE.ROOT:
                return (
                    <>
                        {node.children.map((entry, idx) => (
                            <NodeView key={entry.type + idx} node={entry} />
                        ))}
                    </>
                );
            case AST.NODE_TYPE.THEMATIC_BREAK:
                return <hr />;
            case AST.NODE_TYPE.TEXT:
                return node.value;
            case AST.NODE_TYPE.BREAK:
                return <br />;
            case AST.NODE_TYPE.IMAGE:
                return <img src={node.url} alt={node.alt} title={node.title} {...attr} />;
            case AST.NODE_TYPE.HEADING:
                Tag = 'h' + node.depth;
                break;
            case AST.NODE_TYPE.LINK:
                /* only http: / https: / mailto: / tel: or schema-less URLs are valid */
                if (!/^\s*(https?|mailto|tel):/.test(node.url) && /^\s*[a-zA-Z]+:/.test(node.url)) {
                    Tag = 'span';
                } else {
                    attr.href = node.url;
                    attr.target = node.target;
                    attr.title = node.title;
                }
                break;
            case AST.NODE_TYPE.LIST:
                Tag = node.ordered ? 'ol' : 'ul';
                attr.start = node.start;
                break;
        }
        return (
            <Tag {...attr}>
                {node.children &&
                    (node.children as AST.Content[]).map((entry, idx) => (
                        <NodeView key={entry.type + idx} node={entry} />
                    ))}
            </Tag>
        );
    }
}

interface IRichTextProps {
    text: string;
}

class RichTextView extends React.Component<IRichTextProps> {
    shouldComponentUpdate(nextProps: IRichTextProps) {
        return this.props.text !== nextProps.text;
    }

    render() {
        const tree = parseHtml(this.props.text);
        return <NodeView node={tree} />;
    }
}

export { RichTextView as default, NodeView };
